module.exports = __webpack_public_path__ + "static/img/kong-shop.02ff1219.png";